import React from 'react'

import {
    TableFieldDescription,
    DataMapper,
    DataTransformer,
    InvoicePaymentGroupClickStrategy,
    ThousandSeparatorCreator,
    StateComponentCreator,
    StateExcelDisplayCreator,
} from  '../../../components/BPMTable/TableMapperCreator'
import * as f from '../../../components/BPMTable/BPMInputs'
import { GraphQLDownloadFile } from '../../../components/FileDownloader/FileComponentDownloader'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import {DirectTableQueryBuilder} from "../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder";


const unitQuery = `
    invoicePaymentGroup(id:$id){
      id
      state
      createdAt
      apglFile
      updatedAt
    }
`;

const invoicePaymentStates = {
    'A_0': 'PENDING',
    'A_1': 'PROCESSING',
    'A_2': 'READY',
    'A_3': 'CLOSED'
}

const queries = {tableQueryBuilder: new DirectTableQueryBuilder('allInvoicePaymentGroups'), unitQuery}

class InvoiceGroupTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "InvoiceGroupTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator =  this.createTableCreator(this.constructor.getId(), tableName, queries, new InvoicePaymentGroupClickStrategy())
        tableCreator.setInitialSortField('date', 'desc')
        tableCreator.addDescriptions ([
            new TableFieldDescription(
                'id',
                new DataMapper("id"),
                new f.FilterDescription(new f.TextFilter("id")),
                {label: 'APGL ID'}
            ),
            new TableFieldDescription(
                'date',
                new DataMapper("createdAt"),
                new f.FilterDescription(new f.PeriodFilter("date")),
                {label: 'APGL Date'}
            ),
            new TableFieldDescription(
                'state',
                new DataMapper("state"),
                new f.FilterDescription(new f.InvoicePaymentGroupStateFilter("state")),
                {
                    label: 'State', 
                    componentCreator: new StateComponentCreator(invoicePaymentStates),
                    excelDisplay: new StateExcelDisplayCreator(invoicePaymentStates)
                }
            ),
            new TableFieldDescription(
                'downloadFile',
                new DataMapper("id", "state"),
                new f.FilterDescription(new f.NullCreator()),
                // eslint-disable-next-line eqeqeq
                {label: 'Resource', hideSort:true, transform: new DataTransformer(({id, state}) => state=="A_2" ? <GraphQLDownloadFile resourceType='invoice_payment_group' id={id} /> : null)}
            ),
            new TableFieldDescription(
                'invoicePaymentCount',
                new DataMapper("invoicePaymentCount"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'Invoice Count', hideSort:true, componentCreator:new ThousandSeparatorCreator(), fieldAlign: 'right'}
            ),
        ])

        return tableCreator
    }
}
    
tableCreatorCreatorFactoryCreator.addTableCreatorCreator(InvoiceGroupTableCreator)
    
export default InvoiceGroupTableCreator
